// extracted by mini-css-extract-plugin
export default {"placeholder-text":"placeholder-text__plGGg","interests-tips":"interests-tips__vyw-W"};